<template>
    <div class="crumbsNav no_print clearfix">
        <div v-for="(item,index) in navlist" :key="index" :class="['navSon','cursorPointer',tab === index?'navSonChecked':'','navSon'+templateName]" @click="changeTab(index,$event)">
            {{item}}<span class="crumbsNavNumber" v-if="navNumber[index]>0">（{{navNumber[index]?navNumber[index]:''}}）</span>
        </div>
        <!-- crumbsNavBr -->
        <div class="" :id="'crumbsNavBr'+templateName"></div>
    </div>
</template>
<script>
export default {
    props:{
        navlist:{
            type:Array
        },
        navNumber:{
            type:Array,
            default:()=>[]
        },
        templateName:{
            type:String
        },
        navIndex:{
            type:Number,
            default:0
        }
    },
    data(){
        return{
            tab : this.navIndex,
            firstWidth:0,
        }
    },
    methods:{
        changeTab(index,e){
            let left = 10;
            let width = this.firstWidth;
            for(let i=0;i<document.getElementsByClassName("navSon"+this.templateName).length;i++){
                if(index == i){
                    width = document.getElementsByClassName("navSon"+this.templateName)[i].offsetWidth;
                    break;
                }
                let divStyle = getComputedStyle(document.getElementsByClassName("navSon"+this.templateName)[i], null);
                let marginright = (divStyle.marginRight).split("px")[0];
                left += Number(document.getElementsByClassName("navSon"+this.templateName)[i].offsetWidth)+Number(marginright);
            }
            document.getElementById("crumbsNavBr"+this.templateName).style.width = width+"px";
            document.getElementById("crumbsNavBr"+this.templateName).style.left = left+"px";
            this.tab = index;
            this.$emit("reback",this.tab)
        },
    },
    watch:{
        "navIndex":function (val) {
            this.changeTab(val);
        },
        navlist:{
            immediate:true,
            handler(val){
                this.$nextTick(()=>{
                    this.firstWidth = document.getElementsByClassName("navSon"+this.templateName)[0].offsetWidth;
                    document.getElementById("crumbsNavBr"+this.templateName).style.width = this.firstWidth+"px";
                })
            }
        }
    }
}
</script>
<style scoped>
    .crumbsNav{background-color: #fff;padding:5px 10px 0px 10px;position: relative;}
    .navSon{padding:0 0px;font-size: 14px;line-height: 30px;float: left;margin-right:80px;font-weight: 600;}
    .navSonChecked{color: #B21111;}
    .crumbsNavNumber{font-size: 14px;color:red;margin-left:5px;}
    .crumbsNavBr{width:0px;position: absolute;left:10px;bottom:0;height:3px;background-color:#B21111;transition: 0.3s cubic-bezier(.72,0,.5,1);}
</style>